import {
  shouldShowFarmSetupWizard,
  setOnboardingTenantCreated,
  clearOnboardingTenantCreated,
} from 'actions/app'
import { loadDashboard } from 'api/app'
import { fetchCropsWithCropVariety, fetchDefaultCrops } from 'api/crop'
import { getEquipments } from 'api/equipment'
import { fetchBrands } from 'api/farm'
import { fetchHardware } from 'api/hardware'
import { getHeaders } from 'api/headers'
import { fetchOptions, fetchTenant, createTenant } from 'api/tenant'
import {
  fetchUserAccount,
  fetchUserPreferences,
  createUserAccount,
} from 'api/user'
import { fetchAvailableIntegrations } from 'api/integration'
import http from 'common/http'
import {
  getCurrentSubscription,
  getSubscriptionDetails,
} from 'api/subscriptions'
import {
  fetchNotifications,
  fetchUnreadNotificationsCount,
} from 'api/notification'
import { getCropLegends } from 'api/legend'
import { getPartner, getInitialUnits } from 'common/misc'

import { useAuth0 } from '@auth0/auth0-react'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import PropTypes from 'prop-types'

export default function HttpHandler(props) {
  const { store, baseURL } = props

  const token = useSelector((state) => state.account.token)

  const auth0 = useAuth0()

  useEffect(() => {
    http.init({ baseURL, auth0 })
  }, [])

  // Reset onboardingTenantCreated flag when token changes (re-authentication/password reset)
  // to prevent stale state from interfering with new user flows
  useEffect(() => {
    if (token) {
      store.dispatch(clearOnboardingTenantCreated())
    }
  }, [token])

  const syncAuthRecords = () => {
    return Promise.all([
      store.dispatch(fetchUserAccount()),
      store.dispatch(fetchTenant()),
    ]).then(([userResult, tenantResult]) => {
      const email = auth0?.user?.email

      if (tenantResult === 'TenantEmpty') {
        const tenantInputs = {
          email,
          prefs: {
            units: getInitialUnits(false),
          },
        }
        const partner = getPartner()

        return store
          .dispatch(createTenant({ ...tenantInputs, partner }))
          .then((result) => {
            if (result === 'TenantCreated') {
              store.dispatch(setOnboardingTenantCreated(true))
            } else {
              store.dispatch(setOnboardingTenantCreated(false))
            }

            if (result === 'TenantCreated' && userResult === 'UserEmpty') {
              store.dispatch(setOnboardingTenantCreated(true))
              return store.dispatch(
                createUserAccount({
                  email,
                }),
              )
            }
          })
      }
      store.dispatch(setOnboardingTenantCreated(false))

      if (userResult === 'UserEmpty') {
        return store.dispatch(
          createUserAccount({
            email,
          }),
        )
      }
    })
  }

  useEffect(() => {
    if (token) {
      http.withTokens(token)

      store.dispatch(fetchOptions()).then((response) => {
        if (response?.status === 421 && response?.data?.redirectUrl) {
          window.location.href = response.data.redirectUrl
          return
        }

        syncAuthRecords().then(() => {
          if (
            localStorage.getItem('wizardActiveStep') &&
            localStorage.getItem('wizardActiveStep') != 'null'
          ) {
            store.dispatch(shouldShowFarmSetupWizard())
          }
          store.dispatch(loadDashboard())
        })

        store.dispatch(getCurrentSubscription())
        store.dispatch(getSubscriptionDetails())
        store.dispatch(fetchDefaultCrops())
        store.dispatch(fetchAvailableIntegrations())
        store.dispatch(fetchCropsWithCropVariety())
        store.dispatch(fetchBrands())
        store.dispatch(getHeaders())
        store.dispatch(getEquipments())
        store.dispatch(fetchHardware())
        store.dispatch(fetchUnreadNotificationsCount())
        store.dispatch(fetchNotifications())
        store.dispatch(fetchUserPreferences())
        store.dispatch(getCropLegends())
      })
    }
  }, [token])

  return null
}

HttpHandler.propTypes = {
  store: PropTypes.object.isRequired,
  baseURL: PropTypes.string,
}
